import { FC, useEffect, useMemo, useState } from 'react'
import { PostUid, CommentUid, WithComposeId } from 'interfaces/feed'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import {
  composeMountActionCreator,
  composeUnmountActionCreator,
  composeMountWithPostActionCreator,
  composeMountWithCommentActionCreator,
  composeMountWithReplyActionCreator,
} from 'actions/feedComposeActions'
import { captureWarning } from 'helpers/errorHelpers'
import { createComposeStateCreatedSelector } from 'selectors/feedComposeSelectors'
import { Action } from 'actions'

export const getMountAction = (props: ComposeMountProps): Action | null => {
  const { composeId, isEdit, postUid, commentUid, parentCommentUid, placeholder, focusOnMount, isOpportunityReview } = props
  if (!isEdit && postUid && commentUid && parentCommentUid) {
    return composeMountWithReplyActionCreator.request({
      postUid,
      composeId,
      replyCommentUid: commentUid,
      parentCommentUid: parentCommentUid,

      placeholder,
      focusOnMount,
    })

  } else if (isEdit && postUid && commentUid && !parentCommentUid) {
    return composeMountWithCommentActionCreator.request({
      composeId,
      postUid,
      commentUid,
      isOpportunityReview,

      placeholder,
      focusOnMount,
    })
  } else if (isEdit && postUid && !commentUid && !parentCommentUid) {
    return composeMountWithPostActionCreator.request({
      composeId,
      postUid,

      placeholder,
      focusOnMount,
    })
  } else if (!isEdit && postUid && !commentUid && !parentCommentUid) {
    return composeMountActionCreator({
      composeId,
      type: 'comment',
      postUid,
      isOpportunityReview,

      placeholder,
      focusOnMount,
    })
  } else if (!isEdit && !postUid && !commentUid && !parentCommentUid) {
    return composeMountActionCreator({
      composeId,
      type: 'post',

      placeholder,
      focusOnMount,
    })
  } else {
    return null
  }
}


type ComposeMountProps =
  & WithComposeId
  & {
    isEdit?: boolean
    postUid?: PostUid
    commentUid?: CommentUid
    parentCommentUid?: CommentUid
    isOpportunityReview?: boolean

    placeholder?: string
    focusOnMount?: boolean
    persistent?: boolean
  }

export const ComposeMount: FC<ComposeMountProps> = (props) => {
  const {
    composeId,
    persistent,

    children,
  } = props

  const composeStateCreatedSelector = useMemo(createComposeStateCreatedSelector, [])
  const isComposeStateCreated = useStoreSelector((state) => composeStateCreatedSelector(state, props))

  const [watchdogCounter, setWatchdogCounter] = useState(0)

  useMemo(() => {
    if (!isComposeStateCreated && persistent) {
      setWatchdogCounter(watchdogCounter + 1)
    }
  }, [persistent ? isComposeStateCreated : false])

  const dispatch = useStoreDispatch()
  useEffect(() => {
    const action = getMountAction(props)
    if (!action) {
      captureWarning('ComposeMount wrong props set', props)
      return
    }

    dispatch(action)

    return () => {
      dispatch(composeUnmountActionCreator({ composeId }))
    }
  }, [watchdogCounter])

  return (
    <>
      { children }
    </>
  )
}
